export interface Testimonial {
  id: string;
  name: string;
  title: string;
  company: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    name: '王建国',
    title: '总经理',
    company: '华兴集团',
    content: '今年春节给重要客户送了一批鲍鱼盒子，反馈非常好。礼盒包装精致大方，鲍鱼品质上乘，客户都说这是今年收到最有心意的礼物。以后商务送礼就认准鲍鱼盒子了。',
    rating: 5,
  },
  {
    id: 't-2',
    name: '李美玲',
    title: '采购总监',
    company: '东海实业',
    content: '作为公司的采购负责人，我对供应商的选择非常严格。鲍鱼盒子的产品品质稳定，包装定制服务也很专业，还能根据我们的预算灵活搭配。合作两年了，从未失望。',
    rating: 5,
  },
  {
    id: 't-3',
    name: '张明远',
    title: '品牌创始人',
    company: '远航科技',
    content: '创业初期资金紧张，但合作伙伴的答谢不能少。鲍鱼盒子的中档礼盒性价比极高，既有面子又不至于铺张浪费。团队小伙伴也很喜欢，说比之前送的茶叶烟酒有心意多了。',
    rating: 5,
  },
  {
    id: 't-4',
    name: '陈雅文',
    title: '家庭主妇',
    company: '个人消费者',
    content: '老公生日那天我订了一套家宴套装，按照附赠的食谱做了一桌鲍鱼宴。全家人都赞不绝口，连平时挑食的儿子都吃了两大碗饭。鲍鱼盒子的品质真的没得说，以后家庭聚会就靠它了！',
    rating: 5,
  },
  {
    id: 't-5',
    name: '赵志强',
    title: '区域经理',
    company: '恒通贸易',
    content: '每年中秋都要准备几十份礼品送给区域内的客户，鲍鱼盒子的批量定制服务帮了大忙。发货准时，包装统一美观，客户满意度很高。客服团队也很给力，有什么问题都能及时解决。',
    rating: 4,
  },
  {
    id: 't-6',
    name: '林晓燕',
    title: 'HR总监',
    company: '创新投资',
    content: '公司年会的抽奖礼品选了鲍鱼盒子的至尊套装，抽到的同事简直乐开了花。作为年会策划人，看到同事们收到礼品时的惊喜表情，觉得这个选择太正确了。品质和包装确实没得挑。',
    rating: 5,
  },
];